import * as z from "zod";

export const employeeSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email address"),
  role: z.string().min(1, "Role is required"),
  phoneNumber: z.string().min(1, "Phone number is required"),
  nationality: z.string().min(1, "Nationality is required"),
  idNumber: z.string().min(1, "ID Number is required"),
  address: z.string().min(1, "Address is required"),
  dateOfBirth: z.date(),
  company: z.any(),
});

export type EmployeeFormData = z.infer<typeof employeeSchema>;